<template>
    <VDropdown
        :triggers="triggers"
        :placement="placement"
        :container="'body'"
        :auto-hide="autoHide"
        :distance="distance"
        :popper-class="['sg-bootstrap-dropdown', popperClass]"
    >
        <div :class="['btn-group', groupClass]">
            <slot name="button">
                <button type="button" :class="buttonClass" :disabled="disabled">
                    <i v-if="iconClass" :class="iconClass"></i>
                </button>
            </slot>
        </div>

        <template #popper="{ hide }">
            <div
                :class="['dropdown-menu', 'show', 'border-0', { 'dropdown-menu-right': alignRight }, menuClass]"
                @click="handleMenuClick($event, hide)"
            >
                <slot :hide="hide"></slot>
            </div>
        </template>
    </VDropdown>
</template>

<script>
export default {
    name: 'LimitlessButtonDropdown',
    props: {
        triggers: {
            type: Array,
            default() {
                return ['click'];
            },
        },
        placement: {
            type: String,
            default: 'bottom-end',
        },
        distance: {
            type: Number,
            default: 4,
        },
        autoHide: {
            type: Boolean,
            default: true,
        },
        closeOnItemClick: {
            type: Boolean,
            default: true,
        },
        alignRight: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        buttonClass: {
            type: [String, Array, Object],
            default: 'btn btn-primary dropdown-toggle',
        },
        groupClass: {
            type: [String, Array, Object],
            default: '',
        },
        menuClass: {
            type: [String, Array, Object],
            default: '',
        },
        popperClass: {
            type: [String, Array, Object],
            default: '',
        },
        iconClass: {
            type: String,
            default: '',
        },
    },
    methods: {
        handleMenuClick(event, hide) {
            if (!this.closeOnItemClick) {
                return;
            }

            const clickedItem = event.target.closest('.dropdown-item');
            if (clickedItem && !clickedItem.dataset.keepOpen) {
                hide();
            }
        },
    },
};
</script>

<style scoped>
.sg-bootstrap-dropdown :deep(.v-popper__inner) {
    background: transparent;
    border: 0;
    box-shadow: none;
    overflow: visible;
    padding: 0;
}

.sg-bootstrap-dropdown :deep(.v-popper__arrow-container) {
    display: none;
}

.dropdown-menu.show {
    display: block;
    position: static;
    float: none;
    margin: 0;
}
</style>
